import React from 'react';

export default function CopyIcon({ color }) {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M5.875 4.5V16.375H4.625V3.125H16.375V4.375L6 4.375H5.875V4.5ZM18.125 7.5V7.375H18H9H8.875V7.5V19.5V19.625H9H18H18.125V19.5V7.5ZM7.625 20.875V6.125H19.375V20.875H7.625Z"
        fill={color}
        stroke="white"
        strokeWidth="0.25"
      />
    </svg>
  );
}
